// -*- coding: utf-8 -*-
// Generated by scripts/generate_from_specs.py
// LearningActivities

export default {
    CREATE: "UXADWcXZ",
    EXPLORE: "#j8L0eq3",
    LISTEN: "mkA1R3NU",
    PRACTICE: "VwRCom7G",
    READ: "wA01urpi",
    REFLECT: "3dSeJhqs",
    WATCH: "UD5UGM0z",
};
